import { usingStub } from '../ar';
import { env } from '../config/env';
import type { AppMode } from '../config';

/**
 * Dev overlay. Says which AR module is live, which mode we are in, and how to
 * fire the trigger without a face. Off in production via VITE_DEV_HUD=0.
 */
export function DevHud({ mode, step }: { mode: AppMode; step: string }) {
  if (!env.devHud) return null;
  return (
    <div className="pointer-events-none absolute left-2 top-2 z-50 rounded bg-ink/80 px-2 py-1 font-body text-[10px] leading-tight text-bone/60">
      <div>
        {mode} · {step}
      </div>
      <div>ar: {usingStub ? 'stub' : 'vendor'}</div>
      {usingStub ? <div className="text-straw">space = trigger</div> : null}
      <div className="text-bone/40">?admin=1 · ctrl+shift+A</div>
    </div>
  );
}
